import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dimmer, Grid, Header, Loader } from 'semantic-ui-react';
import { goBack } from 'connected-react-router';
import { IProject } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { projectAction } from '../redux/actions';
import { appState } from '../redux/selectors';
import { PtwCreateComponent } from '../components/ptw/PtwCreateComponent';
import { RootState } from '../redux/types';
import { TranslationComponent } from '../components/TranslationComponent';

interface PtwCreateSceneProps extends Component {
  goBack: typeof goBack;
  projectId: string;
  projectAction: typeof projectAction;
  project: IProject;
}

class PPtwCreateScene extends Component<PtwCreateSceneProps> {
  componentDidMount(): void {
    const { projectId, projectAction } = this.props;
    projectAction(projectId);
  }

  render() {
    const { goBack, project } = this.props;

    if (!project) {
      return (
        <Dimmer active inverted>
          <Loader inverted>
            <TranslationComponent stringKey={'Loading'} />
          </Loader>
        </Dimmer>
      );
    }

    return (
      <React.Fragment>
        <HeaderComponent />
        <NavBar />
        <Grid>
          <Grid.Row>
            <Grid.Column floated="left" textAlign="center" width={2}>
              <Button primary onClick={goBack}>
                <TranslationComponent stringKey={'Back'} />
              </Button>
            </Grid.Column>
            <Grid.Column textAlign="center" width={4}>
              <Header>
                <TranslationComponent stringKey={'{{name}} - New PTW request'} values={{ name: project.name }} />
              </Header>
            </Grid.Column>
            <Grid.Column floated="right" width={2} />
          </Grid.Row>
        </Grid>
        <PtwCreateComponent />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: any) => ({
  projectId: ownProps.match.params.projectId,
  project: appState(state).project,
});

export const PtwCreateScene = connect(mapStateToProps, { goBack, projectAction })(PPtwCreateScene);
